import { useContext } from 'react'
import { TransitionToSuiteContext } from '@/context'

export const useTransitionToSuite = () => useContext(TransitionToSuiteContext)
